'use client'

import {JWTPayload} from 'jose'

import {useMutation, useQueryClient} from '@tanstack/react-query'

import {Routes} from '@/src/config/routes'

import {getClient} from '@/src/shared/utils/api-factory'
import {useRouter} from 'nextjs-toploader/app'
import {handleMutationException} from '../../../../../web/src/shared/utils/error'
import {getInjection} from '@runlab/di'
import {BasketEvents} from '@/src/core/domain/events'

type ConfirmOtpParams = {code: string; phone: string; token: string}
type ConfirmOtpCallbacks = {onError?: (error: Error) => void}

export const useConfirmOtp = () => {
  const queryClient = useQueryClient()
  const router = useRouter()

  const mutation = useMutation({
    mutationFn: async ({code, phone, token: captcha_token}: ConfirmOtpParams) => {
      const client = getClient()

      await client.post<Nullable<JWTPayload>>(Routes.api.auth.login.sendCode, {
        data: {code, phone, captcha_token},
      })
    },
    async onSuccess() {
      // TODO: в отдельный use case
      const next = new URL(location.href).searchParams.get('next')

      await queryClient.invalidateQueries()
      const layoutData = queryClient.getQueryData<Nullable<LayoutData>>(['layout'])

      if (layoutData?.header.cart) {
        getInjection('IEventBus').publish(BasketEvents.basketUpdated({basket: layoutData.header.cart}))
      }

      if (next) {
        router.push(next)
      } else {
        router.push(Routes.profile.page)
      }
    },
    async onError(error) {
      handleMutationException(error)
    },
  })

  const confirmOtp = (params: ConfirmOtpParams, callbacks?: ConfirmOtpCallbacks) => {
    mutation.mutate(params, {
      onError(error) {
        if (error && callbacks?.onError) {
          callbacks.onError(error)
        }
      },
    })
  }

  return {confirmOtp, isPending: mutation.isPending}
}
